import { applyMiddleware, createStore, combineReducers, Store, PreloadedState } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';

import { GlobalState, prescriptionReducer, loginReducer } from './reducers';
import { initialPrescriptionState } from './reducers/prescriptionPad';
import idbBackUpReduxMiddleware from './idbBackupReduxMiddleware';
import { initialLoginState } from './reducers/login';
import { Actions } from './actions';
import appReduxMiddleware from './appReduxMiddleware';
import genieReduxMiddleware from './genieReduxMiddleware';
import undoReduxMiddleware from './undoReduxMiddleware';
import restrictionMiddleware from './restrictionMiddleware';
import sessionReducer, { initialSessionState } from './reducers/session';

export const initialState: GlobalState = {
    prescriptionPad: initialPrescriptionState,
    login: initialLoginState,
    session: initialSessionState,
};

const reducers = combineReducers({
    prescriptionPad: prescriptionReducer,
    login: loginReducer,
    session: sessionReducer,
});

const middlewares = [
    restrictionMiddleware,
    thunk,
    appReduxMiddleware,
    idbBackUpReduxMiddleware,
    genieReduxMiddleware,
    undoReduxMiddleware,
];

if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { createLogger } = require('redux-logger');
    const logger = createLogger({
        duration: true,
        diff: true,
    });
    middlewares.push(logger);
}

const configureStore = (preloaded?: PreloadedState<GlobalState>): { store: Store } => {
    // TODO add types
    const store: Store = createStore<GlobalState, Actions, any, any>(
        reducers,
        preloaded,
        composeWithDevTools(applyMiddleware(...middlewares)),
    );

    return { store };
};

export default configureStore;
